import bookings from "./bookings";
import { BOOKINGS_NAMESPACE } from "@/store/modules/bookings/actions";

export const fromBookings = name => `${BOOKINGS_NAMESPACE}/${name}`;

export default bookings;
